import { jumpLoginPage, jumpActivateLogin } from '@/assets/js/jumpLogin.js'
import { initSentry } from '@/assets/js/sentry'
import Bus from '@/assets/js/vueBus.js'
import SourceList from '@/components/sourceList'
import { showGuardErrorTip, hideGuardErrorTip } from '@/components/guardErrorTip.js'
import { userInfo } from '@/service/base.js'
import $store from '@/store.js'
import Route from '@/views/MySource/index'
import Vue from 'vue'
import Router from 'vue-router'
// 按需加载书写形式
const ReceiverControl = () => import('@/views/receivercontrol/Receiver')
const SourceMap = () => import('@/components/sourceMap')
const SourceMapTrack = () => import('@/views/MySource/sourceMapTrack')
const Alert = () => import('@/views/Alert')
const Token = () => import('@/views/Token/Token')
const RPSOne = () => import('@/views/RPSOne/index')
const MultiView = () => import('@/views/MultiView/Index')
const Setting = () => import('@/views/Setting')
const SettingS = () => import('@/views/Setting')
const SourceContent = () => import('@/views/MySource/sourceContent')
const NewSourceList = () => import('@/views/NewMySource/sourceList')
const NewRoute = () => import('@/views/NewMySource/index')
const MyReceiver = () => import('@/views/MyReceiver/Index')
const GridManage = () => import('@/views/GridManage/switchGrid')
const GridMarket = () => import('@/views/GridMarket/index')
const SearchMonitor = () => import('@/views/SearchMonitor/index')
const MultiControl = () => import('@/views/MultiControl/index')
const Activate = () => import('@/views/Activate/index')
let routes = [
  {
    path: '/',
    name: '',
    redirect: {
      name: 'SourceList'
    }
  },
  {
    path: '/hm',
    component: Route,
    meta: {
      title: 'TRoute'
    },
    children: [
      {
        path: '',
        name: 'SourceList',
        component: SourceList,
        meta: {
          title: 'TMySource'
        }
      },
      {
        path: 'content',
        name: 'SourceContent',
        component: SourceContent,
        meta: {
          title: 'TMySource'
        }
      },
      {
        path: 'SourceMap',
        name: 'SourceMap',
        component: SourceMap,
        meta: {
          title: 'TMySource'
        }
      },
      {
        path: 'SourceMapTrack',
        name: 'SourceMapTrack',
        component: SourceMapTrack,
        meta: {
          title: 'TMySource'
        }
      }
    ]
  },
  {
    path: '/mr',
    name: 'MyReceiver',
    component: MyReceiver,
    meta: {
      title: 'TMyReceivers'
    }
  },
  {
    path: '/hmn',
    component: NewRoute,
    meta: {
      title: 'TRoute'
    },
    children: [
      {
        path: '',
        name: 'NewSourceList',
        component: NewSourceList,
        meta: {
          title: 'TMySource'
        }
      }
    ]
  },
  {
    path: '/rc',
    name: 'AdvanceControl',
    component: ReceiverControl,
    meta: {
      title: 'TAdvanceControl'
    }
  },
  {
    path: '/tm',
    name: 'MultiControl',
    component: MultiControl,
    meta: {
      title: 'TMultiControl'
    }
  },
  {
    path: '/st',
    name: 'Setting',
    component: Setting,
    meta: {
      title: 'TSetting'
    }
  },
  {
    path: '/stS',
    name: 'SettingS',
    component: SettingS,
    meta: {
      title: 'TSetting'
    }
  },
  {
    path: '/mv',
    name: 'MultiView',
    component: MultiView,
    meta: {
      title: 'TMultiView'
    }
  },
  {
    path: '/tkm',
    name: 'Token',
    component: Token,
    meta: {
      title: 'TToken'
    }
  },
  {
    path: '/rps',
    name: 'RPSOne',
    component: RPSOne,
    meta: {
      title: 'RPS'
    }
  },
  {
    path: '/al',
    name: 'Alert',
    component: Alert,
    meta: {
      title: 'TAlert'
    }
  },
  {
    path: '/gd',
    component: GridManage,
    meta: {
      title: 'GridManage'
    }
  },
  {
    path: '/gm',
    component: GridMarket,
    meta: {
      title: 'Grid'
    }
  },
  {
    path: '/smn',
    component: SearchMonitor,
    meta: {
      title: 'SearchMonitor'
    }
  },
  {
    path: '/activate',
    name: 'Activate',
    component: Activate,
    meta: {
      title: 'TActivateDevice'
    }
  }
]
const router = new Router({
  routes,
  linkExactActiveClass: 'tabActive'
})
// WR-346 MINOR-4：localStorage 身份类键的写入守卫 —— **有值才写，无值则删（removeItem）**。
// 两个动机：
// 1. `setItem(key, undefined)` 会存成**字符串 "undefined"**，而下游 10 处 `getItem('userId')` 全是
//    truthy 检查，会把它当成合法 userId；
// 2. 更关键的是**不能保留上一个账号的陈旧 id**：`src/assets/js/common/creatWebsocket.js:109` 的
//    `&businessId=${userId}&notCheckUser=true` —— 服务端不校验用户，客户端给的 businessId 就是权威身份。
//    陈旧 id 是"匹配得到另一个真实账号"的有效值，会跨账号**读**（GridManage/gridList.vue:414-418、
//    RPSOne/index.vue:778-784 读出别人的 userBehavior 并直接套用）与**写**（gridList.vue:398/408、
//    RPSOne/index.vue:797 的 `remark: userId` 写进别人的记录）、以别人身份订阅告警（HeaderCc.vue:441）。
//    而 `null` 只是"匹配不到任何实体"的无效值，各消费点分别走安全分支（唯一降级是
//    MultiControl/index.vue:231-237 把设备判为他人占用——偏保守，无数据风险）。
//    CC 有 support 账号 + monitorSwitch 切视角的场景，陈旧 id 残留是现实风险。
// 本分支的前提本就是异常响应（errorCode='0x0' 但 result 无 id），无法区分"换人"与"后端漏字段"，
// 清掉是唯一保守解；正常 monitorSwitch 路径 result 带 id，走 setItem 正常分支，不受影响 [Claude Code]
const setOrRemoveLocalItem = (key, value) => {
  if (value) {
    localStorage.setItem(key, value)
  } else {
    localStorage.removeItem(key)
  }
}
// WR-346 F：重定向循环断路器状态 —— **严格延续链**，不是"最近跳过哪些 path"的集合。
// 只有本次导航的 to.path 恰好等于链尾刚 next({path}) 过去的目标时，才算同一条重定向链；
// 否则（并发导航、被打断的残留、用户新导航）一律从头计数。
// 这样：真死循环 st→hm→hm 被判据 ① 拦住；a→b→a→b 这类环由延续链长度阈值拦住；
// 而并发/残留之间不会互相污染 —— 集合式判据会把"10s 内跳过一次 /hm"误判成"正在死循环"，
// 把用户放进没有 permission 的页面还弹"无可用页面"，与事实相反（round-2 BLOCKER-1）[Claude Code]
let redirectChain = []
const MAX_REDIRECT_CHAIN = 3
const resetRedirectChain = () => {
  redirectChain = []
}
// NEWCF30-220：userInfo 请求未与导航生命周期绑定 —— 快速连续导航（如跳转刚落地又立刻二次导航）
// 时，较早那次导航的 userInfo 请求可能晚于较新导航的请求返回；若不加判据，会用旧导航取回的
// 身份（userId/EmailName/session/roleInfo/Sentry 用户）覆盖新导航已经写入的身份状态 —— 界面停在
// 新页面，但 localStorage/store 里的身份已经串成上一个导航的。用递增令牌标记"当前最新导航"，
// 只有落身份副作用时令牌仍是最新才写；不影响本次导航自身的 next() 结算（路由跳转是 vue-router
// 自己的事，本判据只管身份类副作用）[Claude Code]
let latestNavToken = 0
// 本次导航是否是链的延续：to.path 必须等于链尾的目标
const isChainContinuation = toPath => redirectChain.length > 0 && redirectChain[redirectChain.length - 1].path === toPath
// WR-346 MINOR-6：提示区原因的优先级（数字越大越根本，低优先级不得覆盖高优先级）[Claude Code]
// WR-346 MINOR-6：提示区原因 → i18n key，以及原因的优先级（数字越大越根本，低优先级不覆盖高优先级）。
// 三种语义各自独立的 key，不复用超时文案 [Claude Code]
const TIP_MESSAGE_KEY = {
  config: 'lang.initConfigFailedTips',
  userInfo: 'lang.initUserInfoFailedTips',
  permission: 'lang.pagePermissionInvalidTips'
}
const TIP_PRIORITY = { config: 3, userInfo: 2, permission: 1 }
router.beforeEach(async (to, from, next) => {
  // NEWCF30-220：本次导航的令牌 —— 落身份副作用前核对它是否仍等于 latestNavToken [Claude Code]
  const navToken = ++latestNavToken
  // WR-346 A：三态结算标记。'next' = 已调 next()；'jump' = 已交给整页跳转（不能再 next()，否则跳转前闪一帧）；
  // null = 未结算，由 finally 兜底放行（兜底必须放行，next(false) 会停在 matched=0 的 "/"，等于还是白屏）。
  // 声明在最外层：从守卫第一行起的任何抛错都要被 finally 兜住，否则照样复现"next() 永不调用" [Claude Code]
  let settled = null
  let pageMark = ''
  // WR-346 MINOR-6：提示区收敛为**单一结算点** —— 守卫内只用局部变量攒"本次导航的原因"，
  // 在 finally 里按它一次性 show / hide。
  // 为什么不在三处各自 show：提示区元素**跨导航存活**（只有 hide 会移除它），若"拒绝被覆盖"的判据
  // 读的是元素上残留的 reason，就会拿上一次导航的原因压这一次；而三个 show 与 hide 的相对位置
  // 也会变成脆弱的隐式约束（挪一行就破）。局部变量天然按导航隔离。
  // `tipReason` 是**声明**（守卫回调体内的 let），不是模块级赋值 —— 模块级会让它永久为真、提示区永不消失 [Claude Code]
  let tipReason = null
  const raiseTip = reason => {
    // 低优先级不覆盖高优先级（config 是更根本的原因）
    if (tipReason && TIP_PRIORITY[tipReason] >= TIP_PRIORITY[reason]) return
    tipReason = reason
  }
  try {
    if (typeof SM == 'object') {
      typeof SM.closeShareBox == 'function' && SM.closeShareBox()
    }
    const mediaDialogDom = document.getElementsByClassName('mediaDialog')
    const dialogBgDom = document.getElementById('dialogBg')
    if (mediaDialogDom.length > 0 && dialogBgDom) {
      // 遍历所有 mediaDialog 元素并移除
      while (mediaDialogDom.length > 0) {
        mediaDialogDom[0].remove() // 移除第一个元素
      }
      // 移除 dialogBgDom
      dialogBgDom.remove()
    }
    // WR-346 B：initConfig 失败不再冒泡 —— 它一旦 reject，守卫函数直接退出，next() 永不被调用 = 整页白屏。
    // 失败时页面能渲染但 initConfig 里的 urlInfo 缺失（TvuTopHeader 会报错），必须给用户一条提示 [Claude Code]
    try {
      await $store.dispatch('common/getInitConfigFn')
    } catch (error) {
      console.error('[router] getInitConfigFn 失败，守卫继续执行', error)
      raiseTip('config')
    }

    pageMark = to.path.split('/')[1]
    pageMark = pageMark === 'stS' ? 'st' : pageMark
    try {
      const res = await userInfo(pageMark)
      if (res.data.errorCode == '0x0') {
        // WR-346 C：result / pagePermissionInfo 为空时不再抛 TypeError 吃掉 next() [Claude Code]
        const result = res.data.result || {}
        const permissionInfo = result.pagePermissionInfo
        // NEWCF30-220：本次 userInfo 响应落地时，若已有更新的导航发生（令牌被后来者推进），
        // 这份响应对身份而言就是陈旧的 —— 丢弃它的身份类副作用，只让最新导航的响应生效，
        // 避免旧响应覆盖新导航已经写入的 userId/EmailName/session/角色/Sentry 用户 [Claude Code]
        if (navToken === latestNavToken) {
          // WR-346 MINOR-4：身份类键有值才写、无值则删 —— 陈旧 id 会在 notCheckUser=true 的 WS 通道上
          // 被当作权威身份，并跨账号读写 userBehavior（详见 setOrRemoveLocalItem 上方注释）[Claude Code]
          setOrRemoveLocalItem('userId', result.id)
          setOrRemoveLocalItem('EmailName', result.email)
          // ⚠️ 反向约定：会话令牌**不套用**上面的删除语义 —— tk 缺失时**不得**删除 NewCCsession3.0，
          // 它仍然有效；删了等于把用户登出，比写入陈旧 id 更严重。三行相邻但语义故意不同，别"顺手统一" [Claude Code]
          if (permissionInfo && permissionInfo.tk) {
            const userSid = window.atob(permissionInfo.tk)
            localStorage.setItem('NewCCsession3.0', userSid)
          }
          let data = res.data.result ? { userInfo: res.data.result } : {}
          $store.commit('common/BASE_USER_INFO', data)
          Bus.$emit('roleInfo', data.userInfo && data.userInfo.role)
          initSentry(result.email || 'unknown@tvunetworks.com')
        }
        if ((permissionInfo != null && permissionInfo.permission) || pageMark == 'gd' || pageMark == 'activate') {
          // 修改网页标题
          if (to.meta.title && to.meta.title != undefined && to.meta.title != 'undefined') {
            document.title = i18n.t('lang.titlePre') + ' - ' + i18n.t(`lang.${to.meta.title}`)
          } else {
            document.title = 'TVU Command Center'
          }
          settled = 'next'
          resetRedirectChain()
          next()
        } else if (permissionInfo && permissionInfo.defeaultPage) {
          // 无权限重定向 defaultPage 属有意设计（KB troubleshooting-cc-menu-tab-not-showing-per-env MT-01）
          const targetPath = `/${permissionInfo.defeaultPage}`
          // 不是本链的延续（并发/残留/新导航）→ 链从头算，避免误杀合法的单次重定向 [Claude Code]
          if (!isChainContinuation(to.path)) resetRedirectChain()
          // WR-346 F：断路判据 —— ① 目标就是当前页（必然自跳自）② 本条延续链已过长 [Claude Code]
          if (to.path === targetPath || redirectChain.length >= MAX_REDIRECT_CHAIN) {
            console.warn('[router] 重定向循环断路：defaultPage 不可用，兜底放行', targetPath, redirectChain.map(item => item.path))
            resetRedirectChain()
            // settled 仍为 null → 由 finally 兜底放行；提示语义是"无可用页面"，不复用超时文案
            raiseTip('permission')
          } else {
            redirectChain.push({ path: targetPath })
            settled = 'next'
            next({ path: targetPath })
          }
        } else {
          // 无权限又没有 defeaultPage：原实现读 null.defeaultPage 抛 TypeError，next() 被吃掉 → 交 finally 兜底
          console.warn('[router] pagePermissionInfo 缺失或无 defeaultPage，兜底放行', pageMark)
          resetRedirectChain()
        }
      } else if (res.data.errorCode == '80000302') {
        settled = 'jump'
        resetRedirectChain()
        window.location.href = res.data.errorInfo
      } else if (res.data.errorCode == '401' || res.data.errorCode == '402') {
        // activate 页 SID 无效走新登录服务专用跳转，其余走通用登出
        settled = 'jump'
        resetRedirectChain()
        pageMark == 'activate' ? jumpActivateLogin() : jumpLoginPage()
      } else {
        // WR-346 C：未知 errorCode 记日志并交 finally 兜底放行，不再无声悬停 [Claude Code]
        console.warn('[router] initLoginUser 返回未知 errorCode，兜底放行', res.data.errorCode)
        resetRedirectChain()
      }
    } catch (error) {
      if (error && error.response && error.response.status == 401) {
        settled = 'jump'
        resetRedirectChain()
        pageMark == 'activate' ? jumpActivateLogin() : jumpLoginPage()
      } else {
        // 客户端超时时 error.response 为 undefined（src/service/index.js 无 response 分支的 reject），原实现在此静默吞掉异常 [Claude Code]
        console.error('[router] initLoginUser 请求失败，兜底放行并提示重试', error)
        resetRedirectChain()
        // WR-346 E：放行后页面没有用户信息，给轻量提示 + 重试按钮（在 finally 统一 show）
        raiseTip('userInfo')
      }
    }
  } catch (fatal) {
    // WR-346 MAJOR-3：守卫前段（SM.closeShareBox / mediaDialog 清理等本仓外部因素）抛错也不得吞掉 next() [Claude Code]
    console.error('[router] 守卫执行异常，兜底放行', fatal)
  } finally {
    if (settled === null) {
      next()
    }
    // 提示区的单一结算点：放在结算**之外**、且单独 try/catch —— 提示区的任何异常都不得影响 next()，
    // 否则就是拿 A 项（必结算）的正确性换 E 项的整洁 [Claude Code]
    try {
      if (tipReason) {
        showGuardErrorTip({ message: i18n.t(TIP_MESSAGE_KEY[tipReason]) })
      } else {
        // 本次导航没有任何失败 → 撤掉上一次导航留下的陈旧提示（否则文案与当次实际脱节）
        hideGuardErrorTip()
      }
    } catch (tipError) {
      console.error('[router] 错误提示区渲染失败（不影响结算）', tipError)
    }
  }
})
Vue.use(Router)
export default router
